import { render, staticRenderFns } from "./CandidateFeedback.vue?vue&type=template&id=33e46624&scoped=true"
import script from "./CandidateFeedback.vue?vue&type=script&lang=js"
export * from "./CandidateFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e46624",
  null
  
)

export default component.exports